export default class Process {
  constructor() {
    // function process() {
    //   // define variables
    //   var items = document.querySelectorAll(".process-card");

    //   // check if an element is in viewport
    //   // http://stackoverflow.com/questions/123999/how-to-tell-if-a-dom-element-is-visible-in-the-current-viewport
    //   function isElementInViewport(el) {
    //     var rect = el.getBoundingClientRect();
    //     return (
    //       rect.top >= 0 &&
    //       rect.left >= 0 &&
    //       rect.bottom <=
    //         (window.innerHeight || document.documentElement.clientHeight) &&
    //       rect.right <=
    //         (window.innerWidth || document.documentElement.clientWidth)
    //     );
    //   }

    //   function callbackFunc() {
    //     for (var i = 0; i < items.length; i++) {
    //       if (isElementInViewport(items[i])) {
    //         items[i].classList.add("in-view");
    //       }
    //     }
    //   }

    //   // listen for events
    //   const processClicked = document.getElementById("process");
    //   processClicked.addEventListener("click", callbackFunc);

    //   //   window.addEventListener("load", callbackFunc);
    //   //   window.addEventListener("resize", callbackFunc);
    //   //   window.addEventListener("scroll", callbackFunc);
    // }
    //   process();

    function observerCard() {
      let observer = new IntersectionObserver(
        function (observable) {
          observable.forEach(function (observable) {
            if (observable.intersectionRatio > 0.75) {
              observable.target.classList.remove("not-visible");
              observer.unobserve(observable.target);
              console.log("Item visible");
            }
          });
        },
        {
          threshold: 0.75,
        }
      );
      let cards = document.querySelectorAll(".process-card");
      cards.forEach(function (item) {
        item.classList.add("not-visible");
        observer.observe(item);
      });
    }
    observerCard();
  }
}
